import React from 'react';
import { connect } from 'react-redux';

import { AddPlugin, RemovePlugin } from '../../actions/actions';

const mapStateToProps = state => {
	return {
		selectedPlugins: state.userChoiceReducer.selectedPlugins,
		isPhone: state.Environment.isPhone
	};
};

const mapDispatchToProps = dispatch => {
	return {
		addPlugin: (id) => dispatch(AddPlugin(id)),
		removePlugin: (id) => dispatch(RemovePlugin(id)),
	};
};

const PluginWrapper = (WrappedComponent) => {
	class Wrapper extends React.Component {
		getPrice = () => {
			if ( this.props.free !== 1 ) {
				return '(' + this.props.price.currency_code + this.props.price.price + ')';
			}

			if ( this.props.trial !== 0 ) {
				return this.props.trial + ' ' + window.wizardData.strings.days + ' ' + window.wizardData.strings.free
			}
			
			return window.wizardData.strings.free;
		}

		getDescription() {
			var description = _.filter(this.props.description, ['language', window.wizardData.locale]);
			return description[Object.keys(description)[0]];
		}
		
		render() {
			var selected = this.props.selectedPlugins.indexOf(this.props.id)

			return (
				<WrappedComponent
					getPrice={this.getPrice}
					isPhone={this.props.isPhone}
					localeDescription={this.getDescription()}
					onClick={selected != -1 ? this.props.removePlugin : this.props.addPlugin}
					selected={selected != -1 ? 1 : '' }
					{...this.props}
				/>
			);
		}
	}
		
	return connect(
		mapStateToProps,
		mapDispatchToProps
	)( Wrapper );
}

export default PluginWrapper;
